/**
 * 设置账户密码弹框
 */
import React from 'react';
import { Modal, message } from 'antd';
import PropTypes from 'prop-types';
import styles from './UserPwdModal.module.scss';
import { XInputPassword } from '@/components/xqxc_ui';
import http from '@/assets/api/http';

class UserPwdModal extends React.Component {

    state = {
        visible: this.props.visible,
        oldLoginPwd: '', // 旧密码
        newLoginPwd: '', // 新密码
        ensureLoginPwd: '', // 确认密码
    }

    // 确认
    _handleOk = () => {
        const { oldLoginPwd, newLoginPwd, ensureLoginPwd } = this.state;
        const reg = /^[0-9a-zA-Z!@#$%^&*(){}_|/'"\\[|\]]{6,16}$/; // 数字、字母、特殊字符
        if (!(reg.test(oldLoginPwd) && reg.test(newLoginPwd) && reg.test(ensureLoginPwd))) {
            message.error('密码限制6-16位，允许输入数字、英文、常用符号（表情除外）');
            return;
        } else if (newLoginPwd != ensureLoginPwd) {
            message.error('两次输入的新密码不一致');
            return;
        }
        const data = {
            oldPwd: oldLoginPwd,
            newPwd: newLoginPwd,
        };
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.updateEmplPwd', data, 'POST').then(() => {
            message.success('密码更新成功');
            this._handleCancel();
        }).catch((e) => {
            message.error(e.message);
        });
    }

    // 取消
    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }

    render() {
        const { visible, oldLoginPwd, newLoginPwd, ensureLoginPwd } = this.state;

        return (
            <Modal
                width={460}
                centered
                title='账户密码设置'
                visible={visible}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <XInputPassword
                        style={{ marginLeft: '28px' }}
                        inputStyle={{ width: '300px' }}
                        label='旧密码'
                        placeholder='请输入旧密码'
                        value={oldLoginPwd}
                        bindThis={this}
                        bindName='oldLoginPwd'
                        isRequired={true}
                        maxLength={16}
                    />
                    <XInputPassword
                        style={{ marginLeft: '28px', marginTop: '30px' }}
                        inputStyle={{ width: '300px' }}
                        label='新密码'
                        placeholder='请输入新密码（长度限制6-16位）'
                        value={newLoginPwd}
                        bindThis={this}
                        bindName='newLoginPwd'
                        isRequired={true}
                        maxLength={16}
                    />
                    <XInputPassword
                        style={{ marginTop: '30px' }}
                        inputStyle={{ width: '300px' }}
                        label='确认新密码'
                        placeholder='请输入新密码（长度限制6-16位）'
                        value={ensureLoginPwd}
                        bindThis={this}
                        bindName='ensureLoginPwd'
                        isRequired={true}
                        maxLength={16}
                    />
                </div>
            </Modal>
        );
    }
}

UserPwdModal.propTypes = {
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default UserPwdModal;